import DateFnsUtils from '@date-io/date-fns'
import { yupResolver } from '@hookform/resolvers'
import theme from '@ifca-root/react-component/src/assets/theme'
import CardContents from '@ifca-root/react-component/src/components/CardList/CardContents'
import EmptyList from '@ifca-root/react-component/src/components/CardList/EmptyList'
import { CommonDialog } from '@ifca-root/react-component/src/components/Dialog/CommonDialog'
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import {
  Divider,
  Grid,
  IconButton,
  ListItem,
  ListItemText,
  Menu,
  MenuItem,
  TextField,
} from '@material-ui/core'
import { MoreVert } from '@material-ui/icons'
import AddIcon from '@material-ui/icons/Add'
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers'
import { ExitConfirmationDialog } from 'components/Dialog/ExitConfirmationDialog'
import { AccountFooter } from 'components/Footer/AccountFooter'
import { TotalAmountFooter } from 'components/Footer/TotalAmountFooter'
import SnackBarContext from 'containers/App/Store/SnackBarContext'
import {
  AcctPermission,
  ApprovalStatus,
  GetAuditAdjustmentbyStatusDocument,
  useCheckExistingAccountPeriodQuery,
  useCreateAuditAdjustmentMutation,
  useDocumentListingLazyQuery,
  useGetAuditAdjustmentAdjDateLazyQuery,
  useGetAuditAdjustmentQuery,
  useGetDocNumTitleQuery,
  useUpdateAuditAdjustmentMutation,
} from 'generated/graphql'
import { handleExitConfirmation } from 'helpers/Form/ExitConfirmation'
import { useMenuOption } from 'helpers/Hooks/useMenuOption'
import { usePermissionChecker } from 'helpers/Hooks/usePermissionChecker'
import { SystemMsgs } from 'helpers/Messages/SystemMsg'
import { amtNumStr, amtStr } from 'helpers/StringNumberFunction/NumFormatters'
import { CommonYupValidation } from 'helpers/YupSchema/yup'
import React, { useContext, useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import * as yup from 'yup'
import '../AuditAdjustment.scss'
import { AuditItems } from './AuditComponent/AuditItemComponent'
import useUploadAttachment from '@ifca-root/react-component/src/utils/hooks/useUploadAttachment'
import { FileUploadInput } from '@ifca-root/react-component/src/components/Input/FileUploadInput'
import { UploadPreview } from '@ifca-root/react-component/src/components/Avatar/UploadPreview'
import { ErrorDialog } from 'components/Dialog/ErrorDialog'
import IconText from '@ifca-root/react-component/src/components/Typography/IconText'
import AuditLog from 'assets/icons/MFRS16/auditlog.svg'

interface AuditAdjustmentProps {
  CompanyID: string
  AdjYearOrPeriod: string
  Description: string
  RefNo: string
  DocDate: Date
  debitAmt: number
}

export const AuditAdjustmentForm = (props: any) => {
  const { formMode } = props

  let form, mode
  switch (formMode) {
    case 'add':
      form = 'New'
      mode = 'add'
      break
    case 'edit':
      form = 'Draft'
      mode = 'edit'
      break
    case 'approve-reject':
      form = 'Approve'
      mode = 'approve-reject'
      break
    case 'resubmit':
      form = 'Resubmit'
      mode = 'edit'
      break
  }

  let location = useLocation()
  let history = useHistory()
  const { CompanyID, AuditAdjustmentID }: any = useParams()
  const user = JSON.parse(localStorage.getItem('loggedInUser'))
  const editData: any = location?.state
  const [openExitConf, setOpenExitConf] = useState(null)
  const [isSubmit, setIsSubmit] = useState(false)
  const [openItem, setOpenItem] = useState<boolean>(false)
  const [itemMode, setItemMode] = useState('')
  const [auditItemDataState, setAuditItemData] = useState([])
  const [errMessage, setErrMessage] = useState(null)
  const [errDialog, setErrDialog] = useState(false)

  const { anchorEl, menu, handleClick, handleClose } = useMenuOption()

  const docAmtReducer = (accumulator, currentValue) =>
    accumulator + currentValue?.DocAmt

  const totalAmount = auditItemDataState?.reduce(docAmtReducer, 0)

  const positiveAmt = auditItemDataState
    ?.filter(v => v?.DocAmt > 0)
    ?.reduce(docAmtReducer, 0)

  const negativeAmt = auditItemDataState
    ?.filter(v => v?.DocAmt < 0)
    ?.reduce(docAmtReducer, 0)

  //Checkbox
  const [state, setState] = useState({
    InterCoFlag: false,
  })

  const handleAdjTypeChange = (event: any) => {
    setValue('AdjYearOrPeriod', event?.target?.value)
    loadAdjustmentDate({
      variables: {
        AdjYearOrPeriod: event?.target?.value,
        CompanyID: CompanyID,
      },
    })
  }

  const AuditAdjustmentFormSchema = yup.object().shape({
    Description: CommonYupValidation.requireField(SystemMsgs.description()),
    AdjYearOrPeriod: CommonYupValidation.requireField(
      SystemMsgs.adjYearOrPeriod()
    ),
    RefNo: CommonYupValidation.requireField(SystemMsgs.referenceNo()),
  })

  const { handleSubmit, register, setValue, control, errors, watch } = useForm<
    AuditAdjustmentProps
  >({
    defaultValues: {
      Description: editData ? editData?.Description : '',
      AdjYearOrPeriod: editData ? editData?.AdjYearOrPeriod : '',
      RefNo: editData ? editData?.RefNo : '',
    },
    mode: 'onSubmit',
    resolver: yupResolver(AuditAdjustmentFormSchema),
  })

  const {
    files,
    setFiles,
    setPreviewFiles,
    handleUploadChange,
    previewFiles,
    remove: removeFile,
    handleEditUpload,
  } = useUploadAttachment()

  /* -------------------------------------------- */
  /*                     QUERY                    */
  /* -------------------------------------------- */

  const [
    fetchdocuments,
    { loading: documentLoading, error: DocError, data: DocData },
  ] = useDocumentListingLazyQuery({
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    fetchPolicy: 'network-only',
    onCompleted: ({ DocumentListing }) => {
      if (!editData?.file) {
        handleEditUpload(
          DocumentListing?.filter(doc => doc?.description !== 'document_pdf')
        )
        previewFiles?.push(
          ...DocumentListing?.filter(
            doc => doc?.description !== 'document_pdf'
          )?.map(x => x?.fileURL)
        )
      }
    },
  })

  useEffect(() => {
    if (!documentLoading && formMode !== 'Add') {
      fetchdocuments({ variables: { refID: editData?.AuditAdjustmentID } })
    }
    if (editData?.file) {
      setFiles(editData?.file)
      setPreviewFiles(
        editData?.file?.map(file => {
          return URL.createObjectURL(file)
        })
      )
    }
  }, [formMode, editData?.AuditAdjustmentID, editData])

  const {
    loading: AuditAdjustmentLoading,
    data: { getAuditAdjustment } = { getAuditAdjustment: [] },
  } = useGetAuditAdjustmentQuery({
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    fetchPolicy: 'network-only',
    variables: {
      CompanyID: CompanyID,
      AuditAdjustmentID: editData?.AuditAdjustmentID,
    },
  })

  const [
    loadAdjustmentDate,
    {
      loading: AuditAdjustmentAdjDateLoading,
      data: { getAuditAdjustmentAdjDate } = { getAuditAdjustmentAdjDate: [] },
    },
  ] = useGetAuditAdjustmentAdjDateLazyQuery({
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    fetchPolicy: 'network-only',
    onCompleted: ({ getAuditAdjustmentAdjDate }) => {
      setValue('DocDate', new Date(getAuditAdjustmentAdjDate?.EndDate))
    },
  })

  const {
    loading: docNumHeaderLoading,
    data: { getDocumentNumberHeader } = {
      getDocumentNumberHeader: [],
    },
  } = useGetDocNumTitleQuery({
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    fetchPolicy: 'network-only',
    variables: {
      CompanyID: CompanyID,
      RefTable: 'GL_AuditAdjustment',
    },
  })

  useEffect(() => {
    if (formMode === 'edit' && editData) {
      const AuditItems = editData?.AuditAdjustmentItem?.map(item => {
        return {
          AuditAdjustmentID: item?.AuditAdjustmentID,
          MasterCOAID: item?.MasterCOAID,
          MasterCOACode: item?.MasterCOA?.Code,
          MasterCOAName: item?.MasterCOA?.Name,
          DocAmt: item?.DocAmt,
          createdTs: item?.createdTs,
          modTs: item?.modTs,
          CostCentreID: item?.CostCentreID,
          CostCentreName: item?.CostCentre?.Name,
          CostCentreCode: item?.CostCentre?.Code,
          Remark: item?.Remark,
        }
      })
      auditItemDataState.push(...AuditItems)
    }
  }, [formMode, editData])

  const [
    createAuditAdjustment,
    {
      loading: createAuditAdjustmentLoading,
      called: createAuditAdjustmentCalled,
      error: createAuditAdjustmentError,
    },
  ] = useCreateAuditAdjustmentMutation({
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    onCompleted: ({ createAuditAdjustment }) => {
      setOpenSnackBar(true)
      setSnackBarMsg(SystemMsgs.createNewRecord())
      setTimeout(() => {
        if (!!isSubmit) {
          history.push({
            pathname: `/general-ledger/${CompanyID}/audit-adjustment/${createAuditAdjustment?.AuditAdjustmentID}/preview`,
          })
        } else {
          history.push({
            pathname: `/general-ledger/${CompanyID}/audit-adjustment/`,
          })
        }
      }, 500)
      localStorage.removeItem('auditAdjustment')
      localStorage.removeItem('auditAdjustmentItem')
    },
  })

  const [
    updateAuditAdjustment,
    {
      loading: updateAuditAdjustmentLoading,
      called: updateAuditAdjustmentCalled,
      error: updateAuditAdjustmentError,
    },
  ] = useUpdateAuditAdjustmentMutation({
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    onCompleted: data => {
      setOpenSnackBar(true)
      setSnackBarMsg(SystemMsgs.updateRecord())
      setTimeout(() => {
        if (!!isSubmit) {
          history.push({
            pathname: `/general-ledger/${CompanyID}/audit-adjustment/${AuditAdjustmentID}/preview`,
          })
        } else {
          history.push({
            pathname: `/general-ledger/${CompanyID}/audit-adjustment/`,
          })
        }
      }, 500)
      localStorage.removeItem('auditAdjustment')
      localStorage.removeItem('auditAdjustmentItem')
    },
  })

  const { setOpenSnackBar, setSnackBarMsg }: any = useContext(
    SnackBarContext as any
  )

  const [errorDia, setErrorDia] = useState<boolean>(false)

  const onSubmit = (data, status) => {
    if (formMode === 'add') {
      if (
        getDocumentNumberHeader?.filter(
          x => x?.RefTable === 'GL_AuditAdjustment'
        )?.length === 0
      ) {
        setOpenSnackBar(true)
        setSnackBarMsg(SystemMsgs.errorNumberingStructure())
      } else {
        createAuditAdjustment({
          variables: {
            input: {
              CompanyID: CompanyID,
              AdjYearOrPeriod: data.AdjYearOrPeriod,
              Description: data.Description,
              DocDate: data?.DocDate,
              RefNo: data.RefNo,
              ApprovalStatus: statusInput(status),
              submittedTs: new Date(),
              Attachment: files,
            },
            itemInput: auditItemDataState?.map(x => {
              return {
                MasterCOAID: x?.MasterCOAID,
                CostCentreID: x?.CostCentreID,
                Remark: x?.Remark,
                DocAmt: parseFloat(amtNumStr(x?.DocAmt)),
                Sequence: x?.Sequence,
              }
            }),
          },
          refetchQueries: [
            {
              query: GetAuditAdjustmentbyStatusDocument,
              variables: {
                CompanyID: CompanyID,
                StatusArr: ['ACTIVE'],
              },
            },
          ],
        })
      }
    } else if (formMode !== 'add')
      updateAuditAdjustment({
        variables: {
          input: {
            AuditAdjustmentID: AuditAdjustmentID,
            AdjYearOrPeriod: data.AdjYearOrPeriod,
            CompanyID: CompanyID,
            Description: data.Description,
            DocDate: data?.DocDate,
            RefNo: data.RefNo,
            ApprovalStatus: statusInput(status),
            submittedTs: new Date(),
            Attachment: files,
          },
          itemInput: auditItemDataState?.map(x => {
            return {
              MasterCOAID: x?.MasterCOAID,
              CostCentreID: x?.CostCentreID,
              Remark: x?.Remark,
              DocAmt: parseFloat(amtNumStr(x?.DocAmt)),
              Sequence: x?.Sequence,
            }
          }),
        },
        refetchQueries: [
          {
            query: GetAuditAdjustmentbyStatusDocument,
            variables: {
              CompanyID: CompanyID,
              StatusArr: ['ACTIVE'],
            },
          },
        ],
      })
  }

  // Status

  let statusInput = mode => {
    let temp
    switch (mode) {
      case 'submit':
        temp = ApprovalStatus.Submit
        break
      case 'draft':
        temp = ApprovalStatus.Active
        break
      case 'approve':
        temp = ApprovalStatus.Approved
        break
      case 'reject':
        temp = ApprovalStatus.Rejected
        break
    }
    return temp
  }

  /** This is for permission purposes */
  const { handlePermDisabled } = usePermissionChecker()
  /**ACL */

  const createUpdateCalled = editData
    ? updateAuditAdjustmentCalled
    : createAuditAdjustmentCalled

  const draftFooterOption = {
    name: 'Save as Draft',
    onClick: () => {
      handleSubmit(data => !createUpdateCalled && onSubmit(data, 'draft'))()
    },
    disabled: handlePermDisabled({
      companyID: CompanyID,
      permEnum: AcctPermission.GeneralLedgerAuditAdjustmentDraft,
    }),
    color: 'primary',
    props: {
      type: 'submit',
    },
  }

  const rejectFooterOption = {
    name: 'Save',
    onClick: () => {
      handleSubmit(data => !createUpdateCalled && onSubmit(data, 'reject'))()
    },
    disabled:
      !!errors?.AdjYearOrPeriod || !!errors?.RefNo || !!errors?.Description
        ? true
        : handlePermDisabled({
            companyID: CompanyID,
            permEnum: AcctPermission.GeneralLedgerAuditAdjustmentUpdate,
          }),
    color: 'primary',
    props: {
      type: 'submit',
    },
  }

  const submitFooterOption = {
    name: 'Submit',
    onClick: () => {
      handleSubmit(data => !createUpdateCalled && onSubmit(data, 'submit'))()
      setIsSubmit(true)
    },
    disabled:
      parseFloat(totalAmount) === 0 && auditItemDataState?.length > 1
        ? false
        : true,
    color: 'primary',
    props: {
      type: 'submit',
    },
  }

  let footerOptions: any[]
  if (editData?.mode === 'resubmit') {
    footerOptions = [rejectFooterOption, submitFooterOption]
  } else {
    footerOptions = [draftFooterOption, submitFooterOption]
  }
  const {
    loading: CheckExistingAccountPeriodLoading,
    data: { CheckExistingAccountPeriod } = {
      CheckExistingAccountPeriod: [],
    },
  } = useCheckExistingAccountPeriodQuery({
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    fetchPolicy: 'network-only',
    variables: {
      CompanyID: CompanyID,
    },
  })

  const checkMonth = CheckExistingAccountPeriod['LastMonth']
  const checkYear = CheckExistingAccountPeriod['LastYear']

  const adjTypeArr = [
    {
      value: 'Previous Month Adjustment',
      disabled: checkMonth === false,
    },
    {
      value: 'Previous Year Adjustment',
      disabled: checkYear === false,
    },
  ]

  const handleDeleteItem = index => {
    if (menu?.index > -1) {
      auditItemDataState.splice(menu?.index, 1)
    }
  }

  /* -------------------------------------------- */
  /*               EXIT CONFIRMATION              */
  /* -------------------------------------------- */

  const hasChanges = () =>
    handleExitConfirmation({
      watch: watch,
      editData: editData,
      formMode: formMode,
      // for item
      itemArr: auditItemDataState,
      itemSuffixID: 'AuditAdjustmentItemID',
      itemTableName: 'AuditAdjustmentItem',
    })

  return (
    <>
      {createAuditAdjustmentLoading && <Loading />}
      {AuditAdjustmentLoading && <Loading />}
      {AuditAdjustmentAdjDateLoading && <Loading />}
      {docNumHeaderLoading && <Loading />}
      {CheckExistingAccountPeriodLoading && <Loading />}
      {updateAuditAdjustmentLoading && <Loading />}
      <MainHeader
        mainBtn="close"
        onClick={() => {
          if (hasChanges() === true) {
            setOpenExitConf(true)
          } else {
            history.push(`/general-ledger/${CompanyID}/audit-adjustment`)
            localStorage.removeItem('auditAdjustment')
            localStorage.removeItem('auditAdjustmentItem')
          }
        }}
        smTitle={'General Ledger'}
        title={user?.companyName}
        routeSegments={[
          { name: 'General Ledger' },
          { name: 'General Ledger' },
          { name: 'Audit Adjustment', current: true },
        ]}
        rightRouteSegments={[
          {
            name:
              formMode === 'add'
                ? 'New'
                : formMode === 'approve-reject'
                ? 'Approve/Reject'
                : 'Edit',
            current: true,
          },
        ]}
      />
      <ContentWrapper float footer>
        <CardContents
          section={{
            header: {
              title: (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <span>Audit Adjustment Details</span>
                  {formMode === 'edit' && (
                    <IconText
                      icon={
                        <img
                          src={AuditLog}
                          style={{
                            width: '17px',
                            marginLeft: '12px',
                            cursor: 'pointer',
                          }}
                          onClick={() => {
                            history.push({
                              pathname: `/general-ledger/${CompanyID}/audit-adjustment/${AuditAdjustmentID}/detail/audit-log`,
                              state: {
                                ID: editData?.AuditAdjustmentID,
                                tableName: 'GL_AuditAdjustment',
                                primaryKey: 'AuditAdjustmentID',
                                primaryItemKey: 'AuditAdjustmentItemID',
                                ...editData,
                              },
                            })
                          }}
                        />
                      }
                      font="desc"
                    />
                  )}
                </div>
              ),
            },
          }}
        >
          <Controller
            render={({ onChange, value }) => (
              <TextField
                label="Adjustment Type"
                margin="normal"
                select
                required
                value={value}
                onChange={e => {
                  onChange(e)
                  handleAdjTypeChange(e)
                }}
                style={{ marginBottom: '-100px' }}
              >
                {adjTypeArr?.map((el, index) => (
                  <MenuItem
                    id="contract-select"
                    key={index}
                    value={el?.value}
                    disabled={el?.disabled}
                  >
                    {el?.value}
                  </MenuItem>
                ))}
              </TextField>
            )}
            name="AdjYearOrPeriod"
            autoComplete="off"
            control={control}
            fullWidth
            ref={register()}
            helperText={errors?.AdjYearOrPeriod?.message}
            error={errors?.AdjYearOrPeriod ? true : false}
            defaultValue={
              formMode === 'edit' || formMode === 'approve-reject'
                ? editData?.AdjYearOrPeriod
                : ''
            }
            disabled={formMode === 'approve-reject'}
          />

          <div style={{ visibility: 'hidden' }}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <Controller
                render={({ onChange, value }) => (
                  <KeyboardDatePicker
                    label="Adjustment Date"
                    format="dd MMM yyyy"
                    showTodayButton
                    allowKeyboardControl
                    margin="normal"
                    required
                    value={watch('DocDate')}
                    disabled
                    onChange={e => {
                      onChange(e)
                    }}
                  ></KeyboardDatePicker>
                )}
                name="DocDate"
                control={control}
                format="dd MMM yyyy"
                value={watch('DocDate')}
                defaultValue={
                  formMode === 'edit' || formMode === 'approve-reject'
                    ? editData?.DocDate
                    : editData?.DocDate
                }
                fullWidth
                required
                disabled
                margin="normal"
                inputRef={register}
                KeyboardButtonProps={{
                  'aria-label': 'change date',
                }}
              />
            </MuiPickersUtilsProvider>
          </div>

          <Controller
            as={TextField}
            id="standard-basic"
            name="RefNo"
            label="Reference No."
            autoComplete="off"
            control={control}
            fullWidth
            required
            margin="dense"
            helperText={errors?.RefNo?.message}
            error={errors?.RefNo ? true : false}
            ref={register}
            defaultValue={
              formMode === 'edit' || formMode === 'approve-reject'
                ? editData?.RefNo
                : ''
            }
            disabled={formMode === 'approve-reject'}
          />

          <Controller
            as={TextField}
            name="Description"
            label="Description"
            required
            autoComplete="off"
            control={control}
            fullWidth
            helperText={errors?.Description?.message}
            error={errors?.Description ? true : false}
            ref={register}
            defaultValue={
              formMode === 'edit' || formMode === 'approve-reject'
                ? editData?.Description
                : ''
            }
            disabled={formMode === 'approve-reject'}
            multiline
          />

          <FileUploadInput
            placeholder={previewFiles.length === 0 ? 'Attachment' : null}
            label={previewFiles.length > 0 ? 'Attachment' : null}
            files={files}
            onHandleUploadChange={handleUploadChange}
            multiple
            imagePreview={
              <>
                {previewFiles?.map((v, i) => (
                  <UploadPreview
                    remove
                    key={v}
                    src={v}
                    onClick={() => removeFile(i)}
                    mediaType={
                      files[i]?.type ?? DocData?.DocumentListing[i]?.mediaType
                    }
                  />
                ))}
              </>
            }
          />
        </CardContents>

        <CardContents
          section={{
            header: {
              title: 'Adjustment Detail',
              onClickAction: () => {
                setItemMode('add')
                setOpenItem(true)
              },

              icon:
                formMode === 'add' || formMode === 'edit' ? (
                  <AddIcon
                    htmlColor="white"
                    fontSize="default"
                    style={{
                      width: '1.3rem',
                      height: '1.3rem',
                      margin: '0',
                      background: theme.palette.primary.main,
                      boxShadow: `1px 1px 4px 0px ${theme.palette.primary.main}`,
                      borderRadius: '3px',
                      color: 'rgba(224,234,254,100)',
                      marginTop: '10px',
                    }}
                  />
                ) : null,
            },
          }}
        >
          <div className="rm-padding table-wrap ">
            {auditItemDataState === undefined ||
            auditItemDataState?.length === 0 ? (
              <EmptyList
                title="No Record Found"
                subtitle="Add New Record now."
              />
            ) : (
              auditItemDataState
                ?.sort(function(a, b) {
                  return a?.Sequence < b?.Sequence ? -1 : 1
                })
                ?.map((v, index) => {
                  return (
                    <>
                      {/* ORIGINAL */}
                      <Grid spacing={1} container className="table-content">
                        <Grid
                          item
                          xs={1}
                          style={{
                            placeSelf: 'start',
                          }}
                        >
                          <span className="xxTitle">{`${index + 1}.`}</span>
                        </Grid>

                        <Grid
                          item
                          xs={7}
                          style={{
                            placeSelf: 'start',
                            marginTop: '8px',
                          }}
                        >
                          <div>
                            <div
                              className="xxTitle text-noflow"
                              style={{ lineBreak: 'anywhere' }}
                            >
                              {v?.MasterCOACode}&nbsp;{v?.MasterCOAName}
                            </div>
                            <div className="desc text-noflow">
                              {v?.CostCentreName}
                            </div>
                            <div className="desc text-noflow">{v?.Remark}</div>
                          </div>
                        </Grid>

                        <Grid
                          item
                          xs={3}
                          style={{
                            placeSelf: 'start',
                            marginTop: '8px',
                            marginRight: 'auto',
                            textAlign: 'right',
                            flexWrap: 'wrap',
                            display: 'flex',
                            justifyContent: 'end',
                          }}
                        >
                          <div>
                            <div className="xxTitle">{amtStr(v?.DocAmt)}</div>
                          </div>
                        </Grid>

                        <Grid
                          item
                          xs={1}
                          style={{
                            marginTop: '0px',
                          }}
                        >
                          <IconButton
                            edge="end"
                            aria-label="delete"
                            aria-controls="menu-list"
                            aria-haspopup="true"
                            onClick={e =>
                              handleClick(e, v?.AuditAdjustmentItemID, index, v)
                            }
                          >
                            <MoreVert />
                          </IconButton>
                        </Grid>
                      </Grid>

                      <Divider
                        variant="fullWidth"
                        style={{ background: '#E4E4E4' }}
                      ></Divider>

                      <Menu
                        id="menu-list"
                        key={index}
                        anchorEl={anchorEl}
                        keepMounted
                        open={Boolean(anchorEl)}
                        onClose={handleClose}
                        onClick={handleClose}
                      >
                        <MenuItem
                          onClick={() => {
                            setItemMode('edit')
                            setOpenItem(true)
                          }}
                        >
                          <span className="mdDesc">Edit</span>
                        </MenuItem>

                        <MenuItem onClick={() => handleDeleteItem(index)}>
                          <span className="mdDesc">Delete</span>
                        </MenuItem>
                      </Menu>
                    </>
                  )
                })
            )}
          </div>
        </CardContents>
      </ContentWrapper>

      {!!openItem && (
        <AuditItems
          openItem={openItem}
          setOpenItem={setOpenItem}
          auditItemData={auditItemDataState}
          description={watch('Description')}
          CompanyID={CompanyID}
          AuditAdjustmentID={AuditAdjustmentID}
          formMode={formMode}
          detailMode={itemMode}
          menu={menu}
          AuditAdjustmentItemID={
            itemMode === 'edit' ? menu?.obj?.AuditAdjustmentItemID : ''
          }
        />
      )}
      {footerOptions?.length > 0 ? (
        <AccountFooter options={[...footerOptions]} />
      ) : null}

      <TotalAmountFooter
        debitCreditInfo={true}
        debitAmt={amtStr(positiveAmt) ?? '0.00'}
        creditAmt={amtStr(Math.abs(negativeAmt)) ?? '0.00'}
      />

      <CommonDialog
        fullWidth={true}
        open={errorDia}
        onClose={() => setErrorDia(false)}
        sections={{
          header: {
            children: (
              <ListItem className="remove-padding">
                <ListItemText
                  primary={
                    <>
                      <span
                        className="smTitle flex-space"
                        style={{ color: 'red' }}
                      >
                        {'Document Numbering is empty'}
                      </span>
                    </>
                  }
                />
              </ListItem>
            ),
          },
          body: () => (
            <div>
              <span>{'Please setup Document Numbering to Submit'}</span>
            </div>
          ),
          footer: {
            actions: [
              {
                displayText: 'Close',
                props: {
                  onClick: () => setErrorDia(false),
                  variant: 'contained',
                  color: 'primary',
                },
              },
            ],
          },
        }}
      />
      <ExitConfirmationDialog
        openExitConf={openExitConf}
        setOpenExitConf={setOpenExitConf}
        onConfirm={() => {
          history.push(`/general-ledger/${CompanyID}/audit-adjustment`)
          localStorage.removeItem('auditAdjustment')
          localStorage.removeItem('auditAdjustmentItem')
        }}
      />
      <ErrorDialog
        errorDia={errDialog}
        setErrorDia={setErrDialog}
        errorMsg={errMessage}
        errorHeaderMsg={'Error!'}
      />
    </>
  )
}
